<template>
  <div>
    <v-btn
      lg
      block
      class="dsk-btn"
      type="submit"
      :disabled="loading"
      :href="redirect_url"
    >
      <img
        src="/img/dsk.svg"
        height="35"
        style="margin-right: 10px"
      />
      <img
        style="margin-right: 20px"
        src="/img/visa-logo.svg"
        height="35"
        alt=""
      />
      <img
        style="margin-right: 20px"
        src="/img/mastercard-logo.svg"
        height="35"
        alt=""
      />
      Плащане с Дебитна / Кредитна карта
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'DskGateway',
  props: {
    event: {
      type: Object,
      required: true,
    },
    secret: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      redirect_url: '',
    }
  },
  created() {
    this.redirect()
  },
  methods: {
    redirect() {
      axios
        .post('/payment-gateway/dsk/redirect', {
          secret: this.secret,
        })
        .then((response) => {
          this.redirect_url = response.data.formUrl
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.dsk-btn {
  background-color: rgba(82, 174, 48, 0.35) !important;
  box-shadow: none !important;
  height: 60px !important;
}
</style>
